import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { BsPlusCircle } from 'react-icons/bs';
import { BiDetail } from 'react-icons/bi';
import { AiOutlineDownload } from 'react-icons/ai';
import { Button, DateInput, Input } from 'ypf-pas-general-ui-components';

import {
  downloadWorkReport,
  postWorkReport,
  putNewWorkReportDates
} from '../../../services/workReport';
import { getPositions } from '../../../services/adminContracts';
import LoaderContext from '../../../context/LoaderProvider';
import useToast from '../../../hooks/useToast';
import { formatAmountDate, formatFullDate, formatsEnum } from '../../../utils/formatUtils';
import useWorkReport from '../../../hooks/useWorkReport';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import { useFilterContext } from '../../../context/FilterDetailSDSContext';
import { downloadPreticket } from '../../../services/programPointsService';
import { useDetailServiceRequest } from '../../../context/DetailServiceRequestProvider';

const WorkReportHeader = (props) => {
  const {
    contractNumber,
    disabledByRol,
    hasWorkReport,
    endingDate,
    setEndingDate,
    editDate,
    setEditDate,
    backupDates,
    setBackupDates,
    numberDays,
    applyTemplate,
    setNumberDays,
    createNewWorkReport,
    setShowModalAddLine,
    setPositions,
    setCreateNewWorkReport,
    setLoading,
    setShowModalOutOfRange,
    hasLines,
    setHasLines,
    isASDS,
    initialDate,
    setInitialDate,
    uploadTemplate,
    disabledEditStateCancelOrFinish

    // workPartPermissions
  } = props;

  const { id } = useParams();

  const { setLoader } = useContext(LoaderContext);

  const { setNewToast } = useToast();
  const actualDate = formatFullDate(new Date(), formatsEnum.FORMAT_DATE_2);
  const fetchDataWithDefaultParams = () => {
    uploadTemplate();
  };
  const { activeTemplateWorkReportModal } = useWorkReportModals();

  const { details } = useDetailServiceRequest();

  const { filter } = useFilterContext();
  const {
    fetchLines,
    setWorkReportId,
    workReportId,
    searchValue,
    setSearchValue,
    calendarDate,
    setCalendarDate,
    setEndDate
  } = useWorkReport();

  const fetchPositions = async () => {
    try {
      const response = await getPositions(contractNumber, false);
      const positionAdapter = response?.data.map((position) => ({
        id: position.id,
        nombre: `${position.numeroPosicion} - ${position.descripcionSap}`,
        descripcionSap: position.descripcionSap,
        descripcionYClick: position.descripcionYClick,
        numeroPosicion: position.numeroPosicion
      }));

      setPositions(positionAdapter);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const createWorkReport = async () => {
    setLoader(true);
    try {
      const response = await postWorkReport({
        idSolicitudServicio: Number(id),
        fechaInicio: initialDate,
        cantDias: Number(numberDays)
      });

      setHasLines(false);
      setWorkReportId(response.id);
      setCreateNewWorkReport(true);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const download = async () => {
    setLoader(true);
    setNewToast({
      type: 'INFO',
      message: 'Descargando, por favor espere.'
    });
    try {
      await downloadWorkReport(workReportId);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const handleDownloadPreticket = async () => {
    setLoader(true);
    setNewToast({
      type: 'INFO',
      message: 'Descargando modelo de preticket.'
    });
    try {
      await downloadPreticket({
        idSolicitud: id,
        nroContrato: contractNumber,
        mensualizada: false,
        numero: details?.numero,
        ubicacion: details?.ubicacionStr
      });

      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: 'Descarga completada correctamente.'
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const updateReportDates = async () => {
    setLoader(true);
    try {
      const res = await putNewWorkReportDates(workReportId, initialDate, numberDays);

      setEndDate(endingDate);
      setLoader(false);
      if (res.actualizado) {
        setCalendarDate(initialDate);
        setNewToast({
          type: 'SUCCESS',
          message: res.titulo
        });
        await fetchLines(initialDate, undefined, filter);
      } else {
        setShowModalOutOfRange(true);
      }
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const handleChangeSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const onSearch = async () => {
    await fetchLines(calendarDate, true, filter);
  };

  return (
    <>
      <Row className="mt-2 align-items-start">
        <Col lg={7}>
          <Row className="g-2 align-items-end">
            <Col md={3} xs={12}>
              <div style={{ transform: 'translateY(15px)' }}>
                <DateInput
                  disabled={((createNewWorkReport || hasWorkReport) && !editDate) || disabledByRol}
                  label="Fecha de inicio "
                  max={isASDS ? actualDate : null}
                  name="initialDate"
                  onChange={(e) => {
                    setInitialDate(e.target.value);
                  }}
                  placeholder="Seleccioná f.i"
                  value={initialDate}
                  widthDateInput="100%"
                />
              </div>
            </Col>

            <Col md={3} xs={12}>
              <Input
                disabled={(!initialDate || createNewWorkReport || hasWorkReport) && !editDate}
                label="Cant. de días"
                max={90}
                min={1}
                name="numberDays"
                onChange={(e) => {
                  const { value } = e.target;

                  if (value > 90) return;
                  setNumberDays(e.target.value);
                }}
                placeholder="Seleccioná cant."
                type="number"
                value={numberDays || '-'}
                widthDateInput="100%"
              />
            </Col>

            <Col md={3} xs={12}>
              <Input
                border="transparent"
                disabled
                errors=""
                label="Fecha de fin"
                name="endDate"
                onChange={() => {
                  /* empty */
                }}
                placeholder="DD/MM/AAAA"
                type="string"
                value={formatAmountDate(endingDate) || ''}
                widthDateInput="100%"
              />
            </Col>

            {(createNewWorkReport || hasWorkReport) && !editDate && (
              <Col className="d-flex align-items-end" md={2} xs={12}>
                <Button
                  disabled={disabledByRol || disabledEditStateCancelOrFinish}
                  label="Editar"
                  onClick={() => {
                    setEditDate(true);
                    setBackupDates({
                      initialDate,
                      numberDays
                    });
                  }}
                  type="button"
                  variant="outline-primary"
                  widthButton="80px"
                />
              </Col>
            )}

            {editDate && (
              <Col className="d-flex align-items-end gap-1" md={3} xs={12}>
                <Button
                  label="Cancelar"
                  onClick={() => {
                    setEditDate(false);
                    setInitialDate(backupDates.initialDate);
                    setNumberDays(backupDates.numberDays);
                  }}
                  type="button"
                  variant="outline-primary"
                  widthButton="80px"
                />

                <Button
                  disabled={
                    !initialDate ||
                    !endingDate ||
                    !numberDays ||
                    !(
                      initialDate !== backupDates.initialDate ||
                      Number(numberDays) !== Number(backupDates.numberDays)
                    )
                  }
                  label="Guardar"
                  onClick={() => {
                    setEditDate(false);
                    updateReportDates();
                  }}
                  type="button"
                  variant="primary"
                  widthButton="80px"
                />
              </Col>
            )}
          </Row>

          <Row className="mt-2 g-3 align-items-end flex-nowrap">
            <Col md={9} xs={12}>
              {hasLines && (
                <Input
                  name="searchLine"
                  onChange={handleChangeSearch}
                  onSearchFunction={() => onSearch()}
                  placeholder="Buscar posición o línea"
                  showIcon
                  type="string"
                  value={searchValue}
                />
              )}
            </Col>
          </Row>
        </Col>

        <Col className="d-flex flex-column justify-content-end" lg={5}>
          {(createNewWorkReport || hasWorkReport) && (
            <>
              <div className="d-flex justify-content-end gap-2 mt-5">
                {hasLines && (
                  <>
                    <Button
                      colorIcon="primary"
                      disabled={disabledByRol || disabledEditStateCancelOrFinish}
                      fontSizeLabel="15px"
                      icon={AiOutlineDownload}
                      iconRight
                      label="Descargar modelo de preticket"
                      onClick={() => {
                        handleDownloadPreticket();
                      }}
                      sizeIcon="17px"
                      type="button"
                      variant="light-gray"
                      widthButton="250px"
                    />

                    <Button
                      colorIcon="primary"
                      fontSizeLabel="15px"
                      icon={AiOutlineDownload}
                      iconRight
                      label="Descargar parte"
                      onClick={() => {
                        download();
                      }}
                      sizeIcon="17px"
                      type="button"
                      variant="light-gray"
                      widthButton="180px"
                    />
                  </>
                )}
              </div>

              <div className={`d-flex justify-content-end gap-2 ${hasLines ? 'mt-4' : 'mt-2'}`}>
                <Button
                  className="button_template"
                  colorIcon="primary"
                  disabled={!applyTemplate}
                  fontSizeLabel="15px"
                  icon={BiDetail}
                  iconRight
                  label="Plantillas"
                  onClick={() =>
                    activeTemplateWorkReportModal({
                      onAccept: fetchDataWithDefaultParams,
                      monthly: false,
                      applied: false,
                      contractNumber,
                      disabledEditStateCancelOrFinish,
                      endingDate,
                      initialDate
                    })
                  }
                  sizeIcon="18px"
                  type="button"
                  variant="light-gray"
                  widthButton="180px"
                />

                <Button
                  colorIcon="primary"
                  disabled={disabledByRol || disabledEditStateCancelOrFinish}
                  fontSizeLabel="15px"
                  icon={BsPlusCircle}
                  iconRight
                  label="Agregar línea al parte"
                  onClick={() => {
                    setShowModalAddLine(true);
                    fetchPositions();
                  }}
                  sizeIcon="17px"
                  type="button"
                  variant="light-gray"
                  widthButton="220px"
                />
              </div>
            </>
          )}
          <Col className="d-flex justify-content-end mt-5" sm={12}>
            {!createNewWorkReport && !hasWorkReport && (
              <div className="d-flex justify-content-end gap-2">
                <Button
                  disabled={disabledByRol}
                  label="Cancelar"
                  onClick={() => {
                    setEndingDate(null);
                    setNumberDays('');
                    setInitialDate(null);
                  }}
                  type="button"
                  variant="outline-primary"
                  widthButton="100px"
                />

                <Button
                  disabled={!endingDate || Number(numberDays) === 0}
                  label="Continuar"
                  onClick={() => {
                    createWorkReport();
                  }}
                  type="button"
                  variant="primary"
                  widthButton="100px"
                />
              </div>
            )}
          </Col>
        </Col>
      </Row>

      <hr className="mt-4 mb-4" />
    </>
  );
};

WorkReportHeader.propTypes = {
  contractNumber: PropTypes.number.isRequired,
  disabledByRol: PropTypes.bool.isRequired,
  hasWorkReport: PropTypes.bool.isRequired,
  endingDate: PropTypes.string,
  setInitialDate: PropTypes.func.isRequired,
  setEndingDate: PropTypes.func.isRequired,
  editDate: PropTypes.bool,
  setEditDate: PropTypes.func.isRequired,
  backupDates: PropTypes.objectOf(PropTypes.string),
  setBackupDates: PropTypes.func.isRequired,
  numberDays: PropTypes.number,
  applyTemplate: PropTypes.bool.isRequired,
  setNumberDays: PropTypes.func.isRequired,
  createNewWorkReport: PropTypes.bool.isRequired,
  setShowModalAddLine: PropTypes.func.isRequired,
  setPositions: PropTypes.func.isRequired,
  setCreateNewWorkReport: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  setShowModalOutOfRange: PropTypes.func.isRequired,
  hasLines: PropTypes.bool.isRequired,
  setHasLines: PropTypes.func.isRequired,
  isASDS: PropTypes.bool.isRequired,
  initialDate: PropTypes.string,
  uploadTemplate: PropTypes.func.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired
};

WorkReportHeader.defaultProps = {
  editDate: null,
  backupDates: null,
  numberDays: null,
  endingDate: '',
  initialDate: ''
};

export default WorkReportHeader;
